import { getCertGroup, getCertTipsCount, getCertDetail, getMyCert } from "@/server/interfaces"

export default {
  namespaced: true,
  state: {
    certGroup: [],
    myCertList: [],
    myCertTipsCount: 0,
    certDetail: {}
  },
  getters: {
    certGroup: state => state.certGroup,
    myCertList: state => state.myCertList,
    myCertTipsCount: state => state.myCertTipsCount,
    certDetail: state => state.certDetail
  },
  mutations: {
    SET_CERT_GROUP(state, certGroup) {
      state.certGroup = certGroup
    },
    SET_MY_CERT(state, myCertList) {
      state.myCertList = myCertList
    },
    SET_CERT_TIPS_COUNT(state, certTipsCount) {
      state.certTipsCount = certTipsCount
    },
    SET_CERT_DETAIL(state, certDetail) {
      state.certDetail = certDetail
    }
  },
  actions: {
    async getCertGroup({ commit, rootState }) {
      const params = {
        activityId: rootState.activityInfo.activityId
      }
      const certGroup = await getCertGroup({ params })
      commit("SET_CERT_GROUP", certGroup)
    },
    async getCertTipsCount({ commit, rootState }) {
      const userId = rootState.userInfo.userInfo.userId
      const params = {
        userId
      }
      const certTipsCount = await getCertTipsCount({ params })
      commit("SET_CERT_TIPS_COUNT", certTipsCount)
    },
    async getCertDetail({ commit }, params) {
      const certDetail = await getCertDetail(params)
      commit("SET_CERT_DETAIL", certDetail)
    },
    async getMyCert({ commit, rootState }, params) {
      const userId = rootState.userInfo.userInfo.userId
      params.params.userId = userId
      const myCert = await getMyCert(params)
      commit("SET_MY_CERT", myCert)
    }
  }
}
